<template>
  <div class="file-display d-flex align-items-center gap-2">
    <i class="material-icons text-primary">{{ fileIcon }}</i>
    <a
      v-if="value"
      href="#"
      @click.prevent="openFile"
      class="text-primary text-decoration-none"
    >
      {{ truncatedFileName }}
    </a>
    <span v-else>Sin archivo adjunto</span>
  </div>
</template>

<script>
import { wencesApi } from "@/api/wencesApi";
import {
  openFileupload,
  showFileuploadAccessError,
} from "@/utils/fileuploadAccess";

export default {
  name: "FileDisplay",
  props: {
    value: {
      type: String,
      default: "",
    },
    maxLength: {
      type: Number,
      default: 20,
    },
  },
  computed: {
    fileIcon() {
      if (!this.value) return "insert_drive_file";

      // Si es una fileKey, extraer la extensión del nombre del archivo
      let fileName;
      if (!this.value.startsWith("http")) {
        // Es una fileKey: timestamp_nombrearchivo.ext
        const parts = this.value.split("_");
        if (parts.length > 1) {
          fileName = parts.slice(1).join("_");
        } else {
          fileName = this.value;
        }
      } else {
        // Es una URL completa
        fileName = this.value.split("/").pop();
      }

      const extension = fileName.split(".").pop().toLowerCase();
      switch (extension) {
        case "pdf":
          return "picture_as_pdf";
        case "doc":
        case "docx":
          return "description";
        case "xls":
        case "xlsx":
          return "table_chart";
        case "jpg":
        case "jpeg":
        case "png":
        case "gif":
          return "image";
        case "mp3":
        case "wav":
          return "audiotrack";
        case "mp4":
        case "avi":
          return "videocam";
        default:
          return "insert_drive_file";
      }
    },
    truncatedFileName() {
      if (!this.value) return "";

      let fileName;
      if (!this.value.startsWith("http")) {
        // Es una fileKey: timestamp_nombrearchivo.ext
        const parts = this.value.split("_");
        if (parts.length > 1) {
          fileName = parts.slice(1).join("_");
        } else {
          fileName = this.value;
        }
      } else {
        // Es una URL completa
        fileName = this.value.split("/").pop();
      }

      return fileName.length > this.maxLength
        ? fileName.substring(0, this.maxLength) + "..."
        : fileName;
    },
  },
  methods: {
    async getPresignedUrl(fileKey) {
      try {
        // Extraer solo el nombre del archivo sin el prefijo fileuploads/
        let cleanFileKey = fileKey;
        if (fileKey.startsWith("fileuploads/")) {
          cleanFileKey = fileKey.replace("fileuploads/", "");
        }

        const response = await wencesApi.get(
          `/api/upload/file/${cleanFileKey}`
        );
        return response.data.url;
      } catch (error) {
        console.error("❌ Error al obtener URL firmada:", error);
        console.error("📊 Detalles del error:", {
          status: error.response?.status,
          statusText: error.response?.statusText,
          data: error.response?.data,
        });
        return null;
      }
    },

    async openFile() {
      if (!this.value) return;
      const result = await openFileupload(this.value, { t: (k) => this.$t(k) });
      if (!result.ok) {
        showFileuploadAccessError(this, result.errorMessage, {
          title: this.$t("Error accessing file."),
          fileRef: this.value,
        });
      }
    },
  },
};
</script>

<style scoped>
.file-display {
  font-size: 0.9em;
}

.file-display .material-icons {
  font-size: 1.2em;
}
</style>
